import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';
import {ServiceProvider} from '../models/serviceProvider.model';

export class UpdateServiceProviderUseCase {
  constructor (private serviceProviderRepository: ServiceProviderRepository) {}

  async execute (id: string, providerData: Partial<ServiceProvider>): Promise<ServiceProvider> {
    return await this.serviceProviderRepository.update(id, providerData);
  }
}
